import type {GetUbiThirdPartyTermsResponse} from '@di-shared/api/di/__generated';
import Environment from '@di-shared/features/environment/Environment';
import Kr from '@di-shared/features/safe-driving-vDSP/SafeDrivingAgreeBottomSheet/.kr';

export interface SafeDrivingAgreeBottomSheetProps {
  vin: string;
  termsData: GetUbiThirdPartyTermsResponse;
}

export default function SafeDrivingAgreeBottomSheet({vin, termsData}: SafeDrivingAgreeBottomSheetProps) {
  return (
    <>
      <Environment.Kr>
        <Kr
          vin={vin}
          termsData={termsData}
        />
      </Environment.Kr>
    </>
  );
}
